import {
  addPaymentSourceApi, editPaymentSourceApi, loadAvailablePaymentSourcesApi, validateApplePayMerchantApi
} from '@common/api/api';
import { log, LOG_LEVELS } from '@common/config/app_logger';

const { useState, useRef } = require('react');

const getClickSource = () => {
  const { clickSource } = window.store.getState().purchaseDetails;
  return clickSource;
};

export const useApplePayProcessing = () => {
  const [processing, setProcessing] = useState(false);
  const [applePayValidated, setApplePayValidated] = useState(false);
  const [error, setError] = useState(null);

  const appleSesionRef = useRef(null);
  const resetError = () => {
    setError(null);
  };

  const startApplePayValidation = (applePaySessionOption, analyticsEvents) => {
    log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'starting apple pay validation');
    if (processing) return;
    analyticsEvents?.trackStartAddingCreditCard(getClickSource(), 'am');
    setProcessing(true);

    try {
      const { ...applePaySessionInfo } = applePaySessionOption;
      const generatedInfo = applePaySessionInfo;
      // This is needed to fix parsing of response
      generatedInfo.automaticReloadPaymentRequest.managementURL = applePaySessionInfo?.automaticReloadPaymentRequest?.managementUrl;
      appleSesionRef.current = new window.ApplePaySession(6, applePaySessionInfo);
      log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'creating new apple pay session');
    } catch (ex) {
      log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Error creating apple pay session', ex);
      window.store.dispatch(analyticsEvents?.trackAddCreditCardFailed({ failedReason: 'sesion creation error' }, 'am'));
      setProcessing(false);
    }

    appleSesionRef.current.oncancel = () => {
      log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'User canceled session');
      analyticsEvents?.trackAddCreditCardFailed({ failedReason: 'user cancel' }, 'am');
      window.store.dispatch({ type: 'paymentOptions:loaded' });
      setProcessing(false);
    };

    let paymentSourceID = null;
    let paymentOptions = null;
    appleSesionRef.current.onvalidatemerchant = ({ validationURL }) => {
      log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Validating merchant');
      addPaymentSourceApi('am').then(({ source: { id }, options }) => {
        paymentOptions = options;
        paymentSourceID = id;
        validateApplePayMerchantApi(id, validationURL).then((merchantSession) => {
          log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Merchant validation success');
          if (appleSesionRef.current) {
            appleSesionRef.current.completeMerchantValidation(merchantSession);
          }
        }).catch((e) => {
          log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Error in on validating apple merchant', e);
        });
      }).catch((e) => {
        log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Error in adding payment source', e);
      });
    };

    appleSesionRef.current.onpaymentauthorized = (event) => {
      log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Patment method authorized');
      const { payment } = event || {};
      if (!payment || !payment.token) {
        if (appleSesionRef.current) {
          appleSesionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE);
        }
        setProcessing(false);
      }

      log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Completing apple pay session merchant');
      appleSesionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS);
      const { token, billingContact, shippingContact } = payment;
      editPaymentSourceApi({
        id: paymentSourceID, params: {
          context: {
            validate_card: true, token, billingContact, shippingContact
          }
        }, type: 'updatePaymentSourceApi'
      }).then(() => {
        log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Editing payment source id', paymentSourceID);
        loadAvailablePaymentSourcesApi().then((sources) => {
          paymentOptions.find((option) => option.kind === 'am').requiresConfiguration = false;
          window.store.dispatch({ type: 'paymentOptions:loaded', options: paymentOptions, skipNextLoad:true });
          window.store.dispatch({ type: 'paymentSources:loaded', ...sources });
        });
        analyticsEvents?.trackCreditCardAdded({ params: { 'payment id': paymentSourceID }, clickSource: getClickSource(), kind:'am' });
        setApplePayValidated(true);
      }).catch((e) => {
        log(LOG_LEVELS.DEBUG, 'ApplePay Merchant', 'Editing payment source Errod', paymentSourceID, e);
        if (e.json) {
          e.json().then((errorData) => {
            setError(errorData);
          });
        }
        analyticsEvents?.trackAddCreditCardFailed({ failedReason: 'api error' }, 'am');
      });
    };
    window.store.dispatch({ type: 'paymentOptions:load' });
    appleSesionRef.current.begin();
  };

  return {
    startApplePayValidation, applePayValidated, error, resetError
  };
};
